const MF_REMOTE_ERRORS = {
  REMOTE_DOWN: {
    code: "REMOTE_DOWN",
    desc: "Remote is unavailable, please supply an url of the remoteEntry.js file generated by moduleFederation plugin."
  },
  NATIVE_DYNAMIC_IMPORT_NOT_AVAILABLE: {
    code: "NATIVE_DYNAMIC_IMPORT_NOT_AVAILABLE",
    desc: `Native dynamic import is not available in the browser... 
    We need browser's import() for loading javascript modules from a cdn...`
  },
  CORRUPT_REMOTE: {
    code: "CORRUPT_REMOTE",
    desc: `Remote is available, the remoteEntry.js is an es module, but remote is corrupt!
    Either it was tampered, or the build was taken in the wrong way...`
  },
  MODULE_NOT_FOUND: {
    code: "MODULE_NOT_FOUND",
    desc: "The module requested was not found in the remote."
  },
  HIDE_CUSTOM_COMPONENT: {
    code: "HIDE_CUSTOM_COMPONENT",
    desc: `Not loading custom form field intentionally for debugging purposes.`
  }
};

const FORM_FIELD_COMPONENTS = {
  EDITABLE_TABLE: "Sheet",
  FORM_FIELD: "FormField",
  READONLY_TABLE: "DataTable",
  CARD: "Card"
};

const PLATFORMS = {
  WEB: "web",
  PWA: "pwa"
};

export { MF_REMOTE_ERRORS, FORM_FIELD_COMPONENTS, PLATFORMS };
